import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNuclearPowerPlant: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconNuclearPowerPlant"><Path fillRule="evenodd" clipRule="evenodd" d="M5.21977 3H17.5593L17.6307 3.92279C17.8381 6.60007 18.057 8.78995 18.4011 10.881C20.5472 12.0768 21.9988 14.3689 21.9988 17V21H1.58984L2.05484 19.67C4.11552 13.7758 4.66371 10.1808 5.14831 3.92279L5.21977 3ZM10.4149 15H19.5828C18.8112 13.2341 17.0491 12 14.9988 12C12.9485 12 11.1864 13.2341 10.4149 15ZM19.9988 17H9.99881V19H19.9988V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNuclearPowerPlant;
